export default __webpack_public_path__ + "8520f5e99abecc4c4c58c3fdfc045f8e.png";